export default __webpack_public_path__ + "static/media/cl.33f2daef.svg";